export const dropFile = (element: HTMLElement, listener: (files: FileList) => void) => {
  let dragEnter = false

  element.addEventListener('dragenter', () => {
    dragEnter = true
  })

  element.addEventListener('dragover', event => {
    dragEnter = false
    const dataTransfer = event.dataTransfer
    if (dataTransfer?.types.length === 1 && dataTransfer.types[0] === 'Files') {
      event.preventDefault()
      dataTransfer.dropEffect = 'copy'
      element.classList.add('dragging')
    }
  })

  element.addEventListener('dragleave', () => {
    if (!dragEnter) {
      element.classList.remove('dragging')
    }
  })

  element.addEventListener('drop', event => {
    event.stopPropagation()
    event.preventDefault()
    element.classList.remove('dragging')
    const files = event.dataTransfer?.files
    files && listener(files)
  })
}
